import {lazy, Suspense, useContext} from 'react'

import PropTypes from 'prop-types'

import {atomIconColors, atomIconSizes} from '@s-ui/react-atom-icon'
import AtomSpinner from '@s-ui/react-atom-spinner'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {moleculeModalSizes} from '@s-ui/react-molecule-modal'
import DisclaimerRatings from '@adv-mt/mt-disclaimer-ratings'
import ListRatings from '@adv-mt/mt-list-ratings'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const MoleculeModal = lazy(() => import('@s-ui/react-molecule-modal'))

const BASE_CLASS = 'mt-Detail-modalDealerRatings'

// TODO: Move this modal to context Modal --> https://jira.ets.mpi-internal.com/browse/MTR-79791
const ModalDealerRatings = ({
  ad,
  isLoading = false,
  isOpenModalDealerRating = false,
  onCloseOpenModalDealerRating,
  pageName,
  ratingsList,
  ratingsSummary
}) => {
  const {i18n, domain} = useContext(Context)
  const {page: pageViewTracking} = useAnalyticsTrack()

  useMount(() => {
    domain
      .get('get_page_tracking_data_use_case')
      .execute({page: pageName, ratings: ratingsSummary, pageType: 'dealer-ratings-modal', ad})
      .then(pageViewTrackingData => {
        pageViewTracking(pageViewTrackingData)
      })
  })

  return (
    <Suspense fallback={<></>}>
      <MoleculeModal
        closeOnEscKeyDown
        closeOnOutsideClick
        header={i18n.t('DEALER_RATINGS.TITLE_TAB')}
        iconClose={<IconClose color={atomIconColors.currentColor} size={atomIconSizes.medium} />}
        isOpen={isOpenModalDealerRating}
        isPageScrollable={false}
        onClose={() => onCloseOpenModalDealerRating(false)}
        size={moleculeModalSizes.LARGE}
      >
        <div className={BASE_CLASS}>
          {isLoading ? (
            <div className={`${BASE_CLASS}-spinner`}>
              <AtomSpinner />
            </div>
          ) : (
            <>
              <DisclaimerRatings />
              <ListRatings ratings={ratingsList} />
            </>
          )}
        </div>
      </MoleculeModal>
    </Suspense>
  )
}

ModalDealerRatings.propTypes = {
  ad: PropTypes.object,
  isLoading: PropTypes.bool,
  isOpenModalDealerRating: PropTypes.bool,
  onCloseOpenModalDealerRating: PropTypes.func,
  pageName: PropTypes.string,
  ratingsList: PropTypes.array,
  ratingsSummary: PropTypes.object
}

export default ModalDealerRatings
